/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SavingInputs */

const th_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังบันทึก…`)
};

const en_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const ja_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存中…`)
};

const zh_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在保存…`)
};

const es_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando…`)
};

const pt_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando…`)
};

const id_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyimpan…`)
};

const fr_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement…`)
};

const tl_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sine-save…`)
};

const vi_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang lưu…`)
};

const ko_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장 중…`)
};

const de_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert…`)
};

const ru_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраняем…`)
};

const tr_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydediliyor…`)
};

const it_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio…`)
};

const pl_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisywanie…`)
};

const uk_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зберігаємо…`)
};

const hi_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहेजा जा रहा है…`)
};

const ar_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الحفظ…`)
};

const ms_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyimpan…`)
};

const bn_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংরক্ষণ হচ্ছে…`)
};

const zh_tw2_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存中…`)
};

const zh_hk2_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存中…`)
};

const ur_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفوظ کیا جا رہا ہے…`)
};

const fa_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال ذخیره…`)
};

const sw_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inahifadhiwa…`)
};

const nl_event_saving = /** @type {(inputs: Event_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met opslaan…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Event_SavingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_saving = /** @type {((inputs?: Event_SavingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SavingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_saving(inputs)
	if (locale === "ja") return ja_event_saving(inputs)
	if (locale === "zh") return zh_event_saving(inputs)
	if (locale === "es") return es_event_saving(inputs)
	if (locale === "pt") return pt_event_saving(inputs)
	if (locale === "id") return id_event_saving(inputs)
	if (locale === "fr") return fr_event_saving(inputs)
	if (locale === "tl") return tl_event_saving(inputs)
	if (locale === "vi") return vi_event_saving(inputs)
	if (locale === "ko") return ko_event_saving(inputs)
	if (locale === "de") return de_event_saving(inputs)
	if (locale === "ru") return ru_event_saving(inputs)
	if (locale === "tr") return tr_event_saving(inputs)
	if (locale === "it") return it_event_saving(inputs)
	if (locale === "pl") return pl_event_saving(inputs)
	if (locale === "uk") return uk_event_saving(inputs)
	if (locale === "hi") return hi_event_saving(inputs)
	if (locale === "ar") return ar_event_saving(inputs)
	if (locale === "ms") return ms_event_saving(inputs)
	if (locale === "bn") return bn_event_saving(inputs)
	if (locale === "zh-TW") return zh_tw2_event_saving(inputs)
	if (locale === "zh-HK") return zh_hk2_event_saving(inputs)
	if (locale === "ur") return ur_event_saving(inputs)
	if (locale === "fa") return fa_event_saving(inputs)
	if (locale === "sw") return sw_event_saving(inputs)
	if (locale === "nl") return nl_event_saving(inputs)
	return en_event_saving(inputs)
});